const mutations = {
    SET_ERROR_STORES(state, payload) {
        state.error = payload;
    }
};

export default mutations;
